// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhiteLabelDomains_card__BCnIp {
  width: 100%;
  border-radius: 1px;
  padding: 2rem;
  height: 100%;
  min-height: 700px;
}

.WhiteLabelDomains_header__wuoig {
  margin-bottom: 20px;
  position: relative;
}

.WhiteLabelDomains_titleRow__2NFm\\+ {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1.5rem;
  justify-content: center;
}

.WhiteLabelDomains_title__D5nmj {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
}

.WhiteLabelDomains_infoBtn__FbVLA {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
}

.WhiteLabelDomains_infoBtn__FbVLA:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  color: #4b5563;
}

.WhiteLabelDomains_subtitle__UBQL9 {
  display: block;
  color: var(--dark2-color);
  font-size: 16px;
  line-height: 1.4;
}

.WhiteLabelDomains_examplesPanel__gEGwZ {
  margin-top: 16px;
  padding: 24px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e2e2;
  animation: WhiteLabelDomains_slideDown__o1e3A 0.2s ease;
}

.WhiteLabelDomains_examplesHeader__MSc4q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.WhiteLabelDomains_examplesTitle__cNwTG {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.WhiteLabelDomains_examplesClose__NoLR3 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid #64748b;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  transition: all 0.15s ease;
}

.WhiteLabelDomains_examplesClose__NoLR3:hover {
  background-color: #e2e8f0;
  color: #475569;
}

.WhiteLabelDomains_examplesGrid__ke6qb {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 12px;
}

.WhiteLabelDomains_exampleCategory__cSOlM {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.WhiteLabelDomains_categoryTitle__8l4X9 {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.WhiteLabelDomains_exampleBtn__CGHDv {
  padding: 16px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.WhiteLabelDomains_exampleBtn__CGHDv:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateX(2px);
}

.WhiteLabelDomains_examplesNote__Wgsjx {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(59, 130, 246, 0.08);
  border-radius: 6px;
  font-size: 12px;
  color: #1d4ed8;
}

.WhiteLabelDomains_examplesNote__Wgsjx svg {
  flex-shrink: 0;
}

@keyframes WhiteLabelDomains_slideDown__o1e3A {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.WhiteLabelDomains_form__BG-C6 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.WhiteLabelDomains_inputRow__z7sVY {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.WhiteLabelDomains_input__AWGmd {
  flex: 1 1;
  font-size: 14px;
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease;
  font-family: inherit;
  width: 100%;
  padding: 16px;
  font-weight: 600;
  border: none;
  background: var(--seconadry-ic-bg);
  border-radius: 8px;
  color: var(--text-color);
  padding-right: 50px;
  outline: none;
}

.WhiteLabelDomains_input__AWGmd:focus {
  box-shadow: 0 4px 10px rgba(88, 101, 242, 0.12);
  border-color: #5865f2;
}

.WhiteLabelDomains_input__AWGmd:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
}

.WhiteLabelDomains_addBtn__rLRBp {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 10px;
  background: var(--primary);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease;
  font-family: inherit;
}

.WhiteLabelDomains_addBtn__rLRBp:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.25);
  background-color: var(--primary-hover);
}

.WhiteLabelDomains_addBtn__rLRBp:active:not(:disabled) {
  transform: translateY(0);
}

.WhiteLabelDomains_addBtn__rLRBp:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.WhiteLabelDomains_hint__jwYOg {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  font-size: 12px;
  color: #64748b;
  border: 1px dashed #e2e8f0;
}

.WhiteLabelDomains_hint__jwYOg svg {
  flex-shrink: 0;
  color: #6366f1;
}

.WhiteLabelDomains_chips__bLYS3 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  min-height: 40px;
  padding: 4px 0;
}

.WhiteLabelDomains_empty__RqRE- {
  color: #9ca3af;
  font-size: 14px;
  padding: 12px 0;
  font-style: italic;
  text-align: center;
  width: 100%;
  /* border: 1px dashed #e5e7eb; */
  border-radius: 8px;
  /* background: #fafafa; */
}

.WhiteLabelDomains_chip__8MPkO {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f3f4ff, #f0f1ff);
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.03);
  transition: all 0.15s ease;
  border: 1px solid #a370ce;
}

.WhiteLabelDomains_chip__8MPkO:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(17, 24, 39, 0.05);
}

.WhiteLabelDomains_localChip__\\+9\\+SR {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
}

.WhiteLabelDomains_chipText__kNPoG {
  padding-right: 4px;
}

.WhiteLabelDomains_localBadge__Yrq\\+A {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.WhiteLabelDomains_chipRemove__NYk7f {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  min-width: 22px;
  min-height: 22px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  transition: all 0.15s ease;
  border: 1px solid #6b7280;
}

.WhiteLabelDomains_chipRemove__NYk7f:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.WhiteLabelDomains_controls__umpYK {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 8px;
  justify-content: flex-end;
}

.WhiteLabelDomains_saveBtn__P-lev {
  background: var(--saveBtn);
  color: var(--white-color);
  padding: 12px 20px;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease;
  font-family: inherit;
  min-width: 140px;
}

.WhiteLabelDomains_saveBtn__P-lev:hover:not(:disabled) {
  background-color: var(--saveHover);
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);
}

.WhiteLabelDomains_saveBtn__P-lev:active:not(:disabled) {
  transform: translateY(0);
}

.WhiteLabelDomains_saveBtn__P-lev:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.WhiteLabelDomains_cancelBtn__b8S0a {
  background: var(--cancelBtn);
  padding: 11px 18px;
  border-radius: 10px;
  cursor: pointer;
  color: var(--heading);
  font-size: 14px;
  transition: all 0.15s ease;
  font-family: inherit;
  outline: none;
  border: none;
}

.WhiteLabelDomains_cancelBtn__b8S0a:hover:not(:disabled) {
  background-color: #f9fafb;
  border-color: #d1d5db;
}

.WhiteLabelDomains_cancelBtn__b8S0a:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.WhiteLabelDomains_message__gmWU5 {
  margin-top: 8px;
  padding: 12px 16px;
  font-size: 18px;
  color: #ff0009;
  font-weight: 500;
  border-radius: 8px;
  /* background-color: #f9fafb; */
  animation: WhiteLabelDomains_WhiteLabelDomains_fadeIn__Mvmxp__3hW9e 0.3s ease;
  /* border-left: 4px solid #10b981; */
}

.WhiteLabelDomains_message__gmWU5:empty {
  display: none;
}

@keyframes WhiteLabelDomains_fadeIn__Mvmxp {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .WhiteLabelDomains_card__BCnIp {
    padding: 0px;
  }
  .WhiteLabelDomains_input__AWGmd {
    padding: 10px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
  }
  .WhiteLabelDomains_title__D5nmj {
    font-size: 1.4rem;
  }
  .WhiteLabelDomains_examplesPanel__gEGwZ {
    padding: 16px;
  }
  .WhiteLabelDomains_exampleBtn__CGHDv {
    padding: 10px;
  }
  .WhiteLabelDomains_addBtn__rLRBp {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    min-width: auto;
    min-height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/WhiteLabelDomains/WhiteLabelDomains.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,uDAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf;;2BAEyB;EACzB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf;;yBAEuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf;;yBAEuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,6EAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".card {\n  width: 100%;\n  border-radius: 1px;\n  padding: 2rem;\n  height: 100%;\n  min-height: 700px;\n}\n\n.header {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 1.5rem;\n  justify-content: center;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 0rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n\n.infoBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: transparent;\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  padding: 0;\n}\n\n.infoBtn:hover {\n  background-color: #f9fafb;\n  border-color: #d1d5db;\n  color: #4b5563;\n}\n\n.subtitle {\n  display: block;\n  color: var(--dark2-color);\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.examplesPanel {\n  margin-top: 16px;\n  padding: 24px;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #e2e2e2;\n  animation: slideDown 0.2s ease;\n}\n\n.examplesHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.examplesTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.examplesClose {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: transparent;\n  border: 1px solid #64748b;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0;\n  transition: all 0.15s ease;\n}\n\n.examplesClose:hover {\n  background-color: #e2e8f0;\n  color: #475569;\n}\n\n.examplesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.exampleCategory {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.categoryTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.exampleBtn {\n  padding: 16px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  color: #475569;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.exampleBtn:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  transform: translateX(2px);\n}\n\n.examplesNote {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(59, 130, 246, 0.08);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #1d4ed8;\n}\n\n.examplesNote svg {\n  flex-shrink: 0;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.inputRow {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  width: 100%;\n}\n\n.input {\n  flex: 1 1;\n  font-size: 14px;\n  transition:\n    box-shadow 0.15s ease,\n    border-color 0.15s ease;\n  font-family: inherit;\n  width: 100%;\n  padding: 16px;\n  font-weight: 600;\n  border: none;\n  background: var(--seconadry-ic-bg);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding-right: 50px;\n  outline: none;\n}\n\n.input:focus {\n  box-shadow: 0 4px 10px rgba(88, 101, 242, 0.12);\n  border-color: #5865f2;\n}\n\n.input:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n}\n\n.addBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  min-width: 44px;\n  min-height: 44px;\n  border-radius: 10px;\n  background: var(--primary);\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  transition:\n    transform 0.12s ease,\n    box-shadow 0.12s ease;\n  font-family: inherit;\n}\n\n.addBtn:hover:not(:disabled) {\n  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.25);\n  background-color: var(--primary-hover);\n}\n\n.addBtn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.addBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.hint {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #64748b;\n  border: 1px dashed #e2e8f0;\n}\n\n.hint svg {\n  flex-shrink: 0;\n  color: #6366f1;\n}\n\n.chips {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  min-height: 40px;\n  padding: 4px 0;\n}\n\n.empty {\n  color: #9ca3af;\n  font-size: 14px;\n  padding: 12px 0;\n  font-style: italic;\n  text-align: center;\n  width: 100%;\n  /* border: 1px dashed #e5e7eb; */\n  border-radius: 8px;\n  /* background: #fafafa; */\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #f3f4ff, #f0f1ff);\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 500;\n  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.03);\n  transition: all 0.15s ease;\n  border: 1px solid #a370ce;\n}\n\n.chip:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(17, 24, 39, 0.05);\n}\n\n.localChip {\n  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);\n}\n\n.chipText {\n  padding-right: 4px;\n}\n\n.localBadge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  background: rgba(59, 130, 246, 0.1);\n  color: #1d4ed8;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.chipRemove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  min-height: 22px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0;\n  transition: all 0.15s ease;\n  border: 1px solid #6b7280;\n}\n\n.chipRemove:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 8px;\n  justify-content: flex-end;\n}\n\n.saveBtn {\n  background: var(--saveBtn);\n  color: var(--white-color);\n  padding: 12px 20px;\n  border-radius: 10px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 14px;\n  transition:\n    transform 0.12s ease,\n    box-shadow 0.12s ease;\n  font-family: inherit;\n  min-width: 140px;\n}\n\n.saveBtn:hover:not(:disabled) {\n  background-color: var(--saveHover);\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);\n}\n\n.saveBtn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.saveBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.cancelBtn {\n  background: var(--cancelBtn);\n  padding: 11px 18px;\n  border-radius: 10px;\n  cursor: pointer;\n  color: var(--heading);\n  font-size: 14px;\n  transition: all 0.15s ease;\n  font-family: inherit;\n  outline: none;\n  border: none;\n}\n\n.cancelBtn:hover:not(:disabled) {\n  background-color: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.cancelBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.message {\n  margin-top: 8px;\n  padding: 12px 16px;\n  font-size: 18px;\n  color: #ff0009;\n  font-weight: 500;\n  border-radius: 8px;\n  /* background-color: #f9fafb; */\n  animation: WhiteLabelDomains_fadeIn__Mvmxp 0.3s ease;\n  /* border-left: 4px solid #10b981; */\n}\n\n.message:empty {\n  display: none;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 480px) {\n  .card {\n    padding: 0px;\n  }\n  .input {\n    padding: 10px 12px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 4px;\n  }\n  .title {\n    font-size: 1.4rem;\n  }\n  .examplesPanel {\n    padding: 16px;\n  }\n  .exampleBtn {\n    padding: 10px;\n  }\n  .addBtn {\n    width: 36px;\n    height: 36px;\n    border-radius: 4px;\n    min-width: auto;\n    min-height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `WhiteLabelDomains_card__BCnIp`,
	"header": `WhiteLabelDomains_header__wuoig`,
	"titleRow": `WhiteLabelDomains_titleRow__2NFm+`,
	"title": `WhiteLabelDomains_title__D5nmj`,
	"infoBtn": `WhiteLabelDomains_infoBtn__FbVLA`,
	"subtitle": `WhiteLabelDomains_subtitle__UBQL9`,
	"examplesPanel": `WhiteLabelDomains_examplesPanel__gEGwZ`,
	"slideDown": `WhiteLabelDomains_slideDown__o1e3A`,
	"examplesHeader": `WhiteLabelDomains_examplesHeader__MSc4q`,
	"examplesTitle": `WhiteLabelDomains_examplesTitle__cNwTG`,
	"examplesClose": `WhiteLabelDomains_examplesClose__NoLR3`,
	"examplesGrid": `WhiteLabelDomains_examplesGrid__ke6qb`,
	"exampleCategory": `WhiteLabelDomains_exampleCategory__cSOlM`,
	"categoryTitle": `WhiteLabelDomains_categoryTitle__8l4X9`,
	"exampleBtn": `WhiteLabelDomains_exampleBtn__CGHDv`,
	"examplesNote": `WhiteLabelDomains_examplesNote__Wgsjx`,
	"form": `WhiteLabelDomains_form__BG-C6`,
	"inputRow": `WhiteLabelDomains_inputRow__z7sVY`,
	"input": `WhiteLabelDomains_input__AWGmd`,
	"addBtn": `WhiteLabelDomains_addBtn__rLRBp`,
	"hint": `WhiteLabelDomains_hint__jwYOg`,
	"chips": `WhiteLabelDomains_chips__bLYS3`,
	"empty": `WhiteLabelDomains_empty__RqRE-`,
	"chip": `WhiteLabelDomains_chip__8MPkO`,
	"localChip": `WhiteLabelDomains_localChip__+9+SR`,
	"chipText": `WhiteLabelDomains_chipText__kNPoG`,
	"localBadge": `WhiteLabelDomains_localBadge__Yrq+A`,
	"chipRemove": `WhiteLabelDomains_chipRemove__NYk7f`,
	"controls": `WhiteLabelDomains_controls__umpYK`,
	"saveBtn": `WhiteLabelDomains_saveBtn__P-lev`,
	"cancelBtn": `WhiteLabelDomains_cancelBtn__b8S0a`,
	"message": `WhiteLabelDomains_message__gmWU5`,
	"WhiteLabelDomains_fadeIn__Mvmxp": `WhiteLabelDomains_WhiteLabelDomains_fadeIn__Mvmxp__3hW9e`,
	"fadeIn": `WhiteLabelDomains_fadeIn__Mvmxp`
};
export default ___CSS_LOADER_EXPORT___;
